export const TypeOfBankAccount = [
  { value: 'Current Account', label: 'Current Account' },
  { value: 'Saving Account', label: 'Saving Account' },
  { value: 'Fixed Deposit Account', label: 'Fixed Deposit Account' },
  { value: 'Joint Account', label: 'Joint Account' },
  { value: 'Corporate Account', label: 'Corporate Account' },
  { value: 'Domiciliary Account', label: 'Domiciliary Account' },
  {
    value: 'Non-resident Nigerian Account',
    label: 'Non-resident Nigerian Account'
  }
];

export const RelationshipType = [
  { value: 'Brother', label: 'Brother' },
  { value: 'Sister', label: 'Sister' },
  { value: 'Father', label: 'Father' },
  { value: 'Mother', label: 'Mother' },
  { value: 'Child', label: 'Child' },
  { value: 'Spouse', label: 'Spouse' },
  { value: 'Other', label: 'Other' }
];
